export const normalizeParametersOptions = (options) =>
    (options || [])
        .map((option) => {
            if (!option) return null;
            if (typeof option === "string") {
                return { value: option, label: option };
            }
            const value = option.value ?? option.libelleParametre ?? "";
            const label = option.label ?? option.libelleParametre ?? value;
            if (!value) return null;
            return { value, label };
        })
        .filter(Boolean)
        .sort((a, b) => a.label.localeCompare(b.label, "fr", { sensitivity: "base" }));



export const uniqueBy = (arr, key) => {
    const seen = new Set();
    return arr.filter(item => {
        const value = item[key];
        if (seen.has(value)) return false;
        seen.add(value);
        return true;
    });
};

export const highlightMatch = (text, q) => {
    if (!q || !text) return text;
    const regex = new RegExp(`(${q.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")})`, "i");
    const parts = text.toString().split(regex);
    return parts.map((part, index) =>
        regex.test(part) ? (
            <mark key={index} style={{ background: "rgba(74, 144, 226, 0.2)", color: "#242166", padding: "2px 4px", borderRadius: "3px" }}>
                {part}
            </mark>
        ) : (
            <span key={index}>{part}</span>
        )
    );
};
